<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('promotion.pageTitle'),
            href: '/admin/promotions',
          },
          {
            text: $t('edit'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="$t('promotion.discount')">
              <div class="ts-space-y-4">
                <div class="row">
                  <div class="col-md-7">
                    <form class="form-horizontal ts-space-y-3">
                      <div class="row">
                        <label
                          class="col-md-3 col-form-label ts-text-xs required ts-font-light"
                        >{{ $t('promotion.eventName') }}</label>
                        <div class="col-md-8">
                          <input v-model="model.promotion_name" type="text" class="form-control" />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('promotion_name')"
                          >{{ errors.first('promotion_name') }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <label
                          class="col-md-3 col-form-label ts-text-xs required ts-font-light"
                        >{{ $t('promotion.discountValue') }}</label>
                        <div class="col-md-8">
                          <input
                            v-model.number="model.promo_discount_value"
                            type="number"
                            class="form-control"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('promo_discount_value')"
                          >{{ errors.first('promo_discount_value') }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <label
                          class="col-md-3 col-form-label ts-text-xs required ts-font-light"
                        >{{ $t('promotion.startDate') }}</label>
                        <div class="col-md-8">
                          <a-date-picker
                            v-model="model.promo_start_date"
                            class="ts-w-full"
                            format="DD-MM-YYYY"
                            valueFormat="DD-MM-YYYY"
                          ></a-date-picker>
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('promo_start_date')"
                          >{{ errors.first('promo_start_date') }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-md-3 col-form-label ts-text-xs"></label>
                        <div class="col-md-8">
                          <ts-checkbox
                            v-model="model.is_no_end_date"
                            class="ts-font-light"
                            @change="() => model.promo_end_date = null"
                          >{{ $t('promotion.tillFurtherNotice') }}</ts-checkbox>
                        </div>
                      </div>
                      <div class="row">
                        <label
                          class="col-md-3 col-form-label ts-text-xs ts-font-light"
                          :class="!model.is_no_end_date ? 'required' : null"
                        >{{ $t('promotion.endDate') }}</label>
                        <div class="col-md-8">
                          <a-date-picker
                            v-model="model.promo_end_date"
                            class="ts-w-full"
                            format="DD-MM-YYYY"
                            valueFormat="DD-MM-YYYY"
                          ></a-date-picker>
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('promo_end_date')"
                          >{{ errors.first('promo_end_date') }}</div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-5">
                    <div
                      class="ts-w-10/12 ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3"
                    >
                      <BranchList v-model="model" />
                      <div
                        class="validate ts-text-xs"
                        v-if="errors.has('branch_id_list')"
                      >{{ errors.first('branch_id_list') }}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ScheduleDay 	
                      v-model="model"
                      :validate="errors"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ProductSaleCode
                      v-model="model"
                      :validate="errors"
                      class="ts-border ts-border-gray-300 ts-rounded-md"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="errors.has('pro_sale_code_id_list')"
                    >{{ errors.first('pro_sale_code_id_list') }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                    <ts-button
                      @click.prevent="$router.push({ name: 'promotion'})"
                    >{{ $t('cancel') }}</ts-button>
                    <ts-button
                      color="primary"
                      outline
                      :waiting="waiting"
                      @click.prevent="onUpdate"
                    >{{ $t('update') }}</ts-button>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductSaleCode from './components/product-sale-code-list'
import BranchList from './components/branch-list'
import ScheduleDay from './components/schedule_day'
import moment from 'moment'
export default {
  name: 'discountEdit',
  components: {
    ProductSaleCode,
    BranchList,
    ScheduleDay
  },
  data() {
    return {
			loading: false,
			waiting: false,
			errors: new Errors(),
      model: {
				promotion_id: null,
        promotion_name: '',
        prom_type_id: 1,
        promo_discount_value: null,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        is_apply_all_product: false,
        pro_sale_code_id_list: [],
        promo_schedule_list: [],
        branch_id_list: []
      }
    }
  },
  methods: {
    ...mapActions('promotion/resource', ['getBranch', 'getSaleCode']),
    ...mapActions('promotion/discount', ['update', 'find']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
			await this.getSaleCode()
			await this.setEditData()
      this.loading = false
    },
    onUpdate(){
			this.waiting = true
			this.update({
				id: this.model.promotion_id,
				data: this.model
			})
        .then(response => {
					this.$toasted.success(response.message)
					this.$router.push({ name: 'promotion'})
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
		},
		async setEditData(){
			await this.find(this.$route.params.id)
				.then(response => {
					let data = response.data
					this.setState(data)
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
		},
		setState(data){
			this.model.promotion_id = data.promotion_id
			this.model.promotion_name = data.promotion_name
      this.model.prom_type_id = 1
      this.model.promo_discount_value = data.promo_discount_value
      this.model.is_no_end_date = data.is_no_end_date
      this.model.promo_start_date = data.promo_start_date
      this.model.promo_end_date = data.promo_end_date
      this.model.is_apply_all_product = data.is_apply_all_product
      this.model.pro_sale_code_id_list = data.pro_sale_codes.map(el => ({
				  pro_sale_code_id: el.pro_sale_code_id,
        	quantity: el.pivot.quantity
			}))
      this.model.branch_id_list = data.branches.map(el => 
				el.branch_id
      )
    
      this.model.promo_schedule_list = []

      for (var i = 1; i <= 7; i++) {
        this.model.promo_schedule_list.push({
          day_id: data.schedules.filter(d => d.day_id == i).reduce((i,v) => i= v.day_id, null),
          time_from: data.schedules.filter(d => d.day_id == i).reduce((i,v) => i= v.time_from, null),
          time_to: data.schedules.filter(d => d.day_id == i).reduce((i,v) => i= v.time_to, null),
          order: i
        })
      }

      this.model.promo_schedule_list = _.orderBy(this.model.promo_schedule_list, ['order'], ['asc'])
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/CLEAR_SETUP')
    next()
  }
}
</script>